<script setup lang="ts">
import { useActionBarStore } from '@/store/actionBar'
import {
  UIDrawer,
  UIDrawerContent,
  UITabs,
  UITabPane,
} from '@gohighlevel/ghl-ui'
import {
  CustomContentLibrary,
  CONTENT_LIBRARY,
  FeaturedContentLibrary,
  ContentLibraryCategoryEnum,
} from '@gohighlevel/ghl-proposals-common'
import { computed, onMounted } from 'vue'
import { useDocument } from '../../../composition'

const storeAction = useActionBarStore()
const {
  getContentLibraryCustomContentCount,
  contentLibraryCustomContentCount,
} = useDocument()

function onClose() {
  storeAction.toggleContentLibrary()
}

function onEnd() {
  storeAction.setContentLibraryDragState(false)
  storeAction.setFloatingElementDragging(false)
}

const startDrag = (evt: any, item: any) => {
  storeAction.setDragState(true)
  storeAction.setContentLibraryDragState(true)
  evt.dataTransfer.dropEffect = 'move'
  evt.dataTransfer.effectAllowed = 'move'
  evt.dataTransfer.setData('name', CONTENT_LIBRARY)
  evt.dataTransfer.setData('action', 'add')
  evt.dataTransfer.setData('contentId', item?._id || item.id)
  evt.dataTransfer.setData('content', JSON.stringify(item))
  evt.dataTransfer.setDragImage(evt.target, 0, 0)
}

const defaultTab = computed(() => {
  if (contentLibraryCustomContentCount.value === 0) {
    return ContentLibraryCategoryEnum.featured
  }
  return ContentLibraryCategoryEnum.custom
})

onMounted(async () => {
  await getContentLibraryCustomContentCount()
})
</script>

<template>
  <UIDrawer
    :width="440"
    id="content-library-drawer"
    :show="storeAction.contentLibrary"
    @update:show="onClose"
    :placement="'left'"
    to="#drawer-target"
    class="!shadow-page h-screen"
    :trap-focus="false"
  >
    <UIDrawerContent
      id="content-library-drawer-content"
      :title="$t('contentLibrary.contentLibraryTitle')"
      :description="$t('contentLibrary.contentLibraryDescription')"
    >
      <div
        class="proposal-content-library-scroll w-full pr-3"
        id="content-library-scroll"
      >
        <UITabs
          :type="'segment'"
          :animated="true"
          :placement="'top'"
          :value="undefined"
          :defaultValue="defaultTab"
          :id="'content-library-tabs'"
        >
          <UITabPane
            :name="ContentLibraryCategoryEnum.custom"
            :tab="$t('contentLibrary.custom')"
          >
            <CustomContentLibrary
              @on-drag-start="startDrag"
              @on-drag-end="onEnd"
            />
          </UITabPane>
          <UITabPane
            :name="ContentLibraryCategoryEnum.featured"
            :tab="$t('contentLibrary.featured')"
          >
            <FeaturedContentLibrary
              @on-drag-start="startDrag"
              @on-drag-end="onEnd"
            />
          </UITabPane>
        </UITabs>
      </div>
    </UIDrawerContent>
  </UIDrawer>
</template>

<style lang="scss" scoped>
.proposal-content-library-scroll {
  height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
